module.exports = __webpack_public_path__ + "img/deluxe-guestroom-img.c188a304.jpg";